var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard5Img(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "#A8A8A8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AI QUIZ BOOSTER",
    clipPath: "url(#clip0_13_7334)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 8804,
    transform: "translate(-742 -2827)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 64",
    opacity: 0.2,
    filter: "url(#filter0_f_13_7334)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.5,
    cy: -274.5,
    rx: 374.5,
    ry: 395.5,
    transform: "rotate(90 192.5 -274.5)",
    fill: "#FFBB00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 237861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main",
    opacity: 0.9975,
    filter: "url(#filter1_d_13_7334)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -57.4062,
    y: -39.46,
    width: 546.91,
    height: 265.77,
    rx: 19,
    fill: "white",
    fillOpacity: 0.01,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    id: "span.lqd-bg-layer"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -57.4062,
    y: -39.46,
    width: 546.91,
    height: 265.76,
    rx: 19,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    clipPath: "url(#clip1_13_7334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.5043 24.4432V26.6099H11.3434V24.4432H26.5043ZM23.2555 19.0266H11.3434V21.1932H23.2555V19.0266ZM20.0068 13.6099H11.3434V15.7766H20.0068V13.6099ZM16.758 8.19325H11.3434V10.3599H16.758V8.19325ZM4.39763 1.24475L0.607422 5.03642L2.13867 6.56825L4.84596 3.85992V26.6099H7.0118V3.85992L9.71908 6.56825L11.2504 5.03642L7.46012 1.24475C6.61653 0.400837 5.24123 0.400837 4.39763 1.24475Z",
    fill: "url(#paint0_linear_13_7334)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_13_7334",
    x: -607.1,
    y: -1053.1,
    width: 1599.2,
    height: 1557.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 202.05,
    result: "effect1_foregroundBlur_13_7334"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13_7334",
    x: -101.406,
    y: -79.46,
    width: 634.91,
    height: 353.77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.341176 0 0 0 0 0.729412 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_7334"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_7334",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_7334",
    x1: 0.607422,
    y1: 0.611816,
    x2: 26.6053,
    y2: 26.5085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB89A0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_7334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 8804,
    fill: "white",
    transform: "translate(-742 -2827)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13_7334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.99,
    height: 26,
    fill: "white",
    transform: "translate(0.513672 0.609863)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard5Img);
export default __webpack_public_path__ + "static/media/card5Img.dadc2311e7e4e97d78f090a8e4330972.svg";
export { ForwardRef as ReactComponent };